import { Injectable, signal } from '@angular/core';
import { LightboxImage } from '@/shared/components/lightbox/lightbox.component';

/**
 * Pilote l'unique `<app-lightbox>` monté dans le `MainLayout`.
 *
 * Évite de dupliquer l'état (`open`/`images`/`index`) dans chaque page ou
 * drawer qui affiche du HTML riche : `appHtmlLightbox` appelle `open()`.
 */
@Injectable({ providedIn: 'root' })
export class LightboxService {
  private readonly _images = signal<LightboxImage[]>([]);
  private readonly _open = signal(false);
  private readonly _startIndex = signal(0);

  readonly images = this._images.asReadonly();
  readonly isOpen = this._open.asReadonly();
  readonly startIndex = this._startIndex.asReadonly();

  open(images: LightboxImage[], index = 0) {
    if (images.length === 0) return;
    this._images.set(images);
    this._startIndex.set(Math.min(Math.max(index, 0), images.length - 1));
    this._open.set(true);
  }

  setOpen(open: boolean) {
    this._open.set(open);
  }

  close() {
    this._open.set(false);
  }
}
